import { Table } from '@mantine/core';
import React from 'react';
import './x-table.styles.css';

interface Props {
  children?: React.ReactNode;
}
function XTable(props: Props) {
  const { children } = props;
  return (
    <>
      <Table
        highlightOnHover
        sx={{
          '& thead tr th': { height: 50 },
          whiteSpace: 'nowrap',
          overflow: 'auto',
        }}
        horizontalSpacing='md'
        className='x-table'
      >
        {children}
      </Table>
    </>
  );
}

export default XTable;
